var _linearGradient, _path, _linearGradient2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnreal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 64 64",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "pVl6bdv8xR2_oynBRXpQLa_69503_gr1",
    x1: 32,
    x2: 32,
    y1: 6,
    y2: 58,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#pVl6bdv8xR2_oynBRXpQLa)",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M32 7A25 25 0 1 0 32 57A25 25 0 1 0 32 7Z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "pVl6bdv8xR2_oynBRXpQLb_69503_gr2",
    x1: 31.03,
    x2: 31.03,
    y1: 16,
    y2: 48,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#pVl6bdv8xR2_oynBRXpQLb_69503_gr2)",
    d: "M13.125,36c-0.961-7.967,8.851-17.938,17.349-20c0,0-3.474,2.449-3.474,4.525 c0,4.154,1.971,2.745,1.971,2.745s0.039,14.986,0.039,16.057c0,1.071,0.985,1.673,2.365,1.673C32.755,41,36,39.25,36,39.25 s0-11.903,0-13.375s-1.644-2.822-2.438-3.515c2.123,0,3.088,0.737,3.088,0.737s2.756-3.643,9.919-5.557 C45.481,18.951,42,23.227,42,24.5s0,13.763,0,14.5s0.849,1,1.375,1c0.526,0,2.904-0.691,5.625-3.75c0,0.93-3.632,7.118-9.131,10.746 L36.25,44l-3.739,4c0,0-9.261-0.5-12.511-6c0.967,0.146,3,0.54,3-1s0-11.495,0-12.5S22.479,27,21.625,27 C20.771,27.001,17.747,27.685,13.125,36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreal);
export default __webpack_public_path__ + "static/media/unreal.566098dd1c3b4a97b10caaeb94e0c227.svg";
export { ForwardRef as ReactComponent };